import React from 'react'
import PropTypes from 'prop-types'
import { Ratings as StarRating } from '@sainsburys-tech/bolt'

import * as Styled from './ReviewsSummaryBox.styles'

const ReviewsSummaryBox = ({ title, overallRating, message, smallMessage, 'data-test': dataTest }) => {
  return (
    <Styled.Box data-test={dataTest}>
      <h2>{title}</h2>
      {overallRating && (
        <StarRating
          rating={overallRating}
          position='center'
          className='rating'
          data-test='review-summary-box-ratings'
        />
      )}
      {message && <p>{message}</p>}
      {smallMessage && <small>{smallMessage}</small>}
    </Styled.Box>
  )
}

ReviewsSummaryBox.propTypes = {
  /**
   * Specify the content title of the box
   */
  title: PropTypes.string.isRequired,
  /**
   * Specify the rating stars values
   */
  overallRating: PropTypes.number,
  /**
   * Specify the text of normal text
   */
  message: PropTypes.string,
  /**
   * Specify the text of small text
   */
  smallMessage: PropTypes.string,
  /**
   * Specify an optional data-test attribute to be added to your ReviewSummaryBox for e2e testing
   */
  'data-test': PropTypes.string
}

ReviewsSummaryBox.defaultProps = {
  'data-test': 'review-summary-box'
}

export default ReviewsSummaryBox
